import { Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import { useFormatCurrency } from 'domains/Billing/hooks';
import { GatewayData } from 'domains/Orders/Orders/pages/OrderDetailsPage/components/CardPayment/NewCardPayment';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface OrderPaymentStatusMarkedModal {
  orderId: number;
  total: number;
  showTotal?: boolean;
  show: boolean;
  gatewayData?: GatewayData;
  onClose: () => void;
  onConfirm: (gatewayData?: GatewayData) => void;
}

function OrderPaymentStatusMarkedModal({
  orderId,
  total,
  showTotal,
  show,
  gatewayData,
  onClose,
  onConfirm,
  t,
}: Readonly<
  OrderPaymentStatusMarkedModal & { t: ReturnType<typeof useTranslationOrders> }
>) {
  const handleOnConfirm = () => {
    onConfirm(gatewayData);
  };

  const formatCurrency = useFormatCurrency();

  return (
    <Modal open={show} onDismiss={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body padding="none">
        <Text>
          {showTotal
            ? t('body', {
                total: formatCurrency(total),
                orderId: orderId,
              })
            : t('bodyWithoutTotal', { orderId: orderId })}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <CancelAndConfirmButtons
          onCancel={onClose}
          onConfirm={handleOnConfirm}
          cancelText={t('cancel')}
          confirmText={t('confirm')}
        />
      </Modal.Footer>
    </Modal>
  );
}

export function OrderMarkAsPaidModal({
  orderId,
  total,
  showTotal = true,
  show,
  gatewayData,
  onClose,
  onConfirm,
}: Readonly<OrderPaymentStatusMarkedModal>) {
  const t = useTranslationOrders('orderMarkAsPaidModal');

  return (
    <OrderPaymentStatusMarkedModal
      orderId={orderId}
      total={total}
      showTotal={showTotal}
      show={show}
      gatewayData={gatewayData}
      onClose={onClose}
      onConfirm={onConfirm}
      t={t}
    />
  );
}

export function OrderMarkAsRefundedModal({
  orderId,
  total,
  showTotal = true,
  show,
  gatewayData,
  onClose,
  onConfirm,
}: Readonly<OrderPaymentStatusMarkedModal>) {
  const t = useTranslationOrders('orderMarkAsRefundedModal');

  return (
    <OrderPaymentStatusMarkedModal
      orderId={orderId}
      total={total}
      showTotal={showTotal}
      show={show}
      gatewayData={gatewayData}
      onClose={onClose}
      onConfirm={onConfirm}
      t={t}
    />
  );
}
